import script from "./RwaProjectInvestmentStrategy.vue?vue&type=script&setup=true&lang=ts"
export * from "./RwaProjectInvestmentStrategy.vue?vue&type=script&setup=true&lang=ts"

import "./RwaProjectInvestmentStrategy.vue?vue&type=style&index=0&id=35f79dd8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35f79dd8"]])

export default __exports__